"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.completeStep = completeStep;
const dist_1 = require("../../fs/dist");
async function completeStep(input, deps) {
    const weaveId = await (0, dist_1.resolveWeaveSlugForPlan)(deps.loomRoot, input.planUlid);
    const stepIndex = input.step - 1;
    const weave = await deps.loadWeave(deps.loomRoot, weaveId);
    const plan = weave.threads.flatMap((t) => t.plans).find((p) => p.id === input.planUlid);
    if (!plan) {
        throw new Error(`Plan '${input.planUlid}' not found in weave '${weaveId}'`);
    }
    if (plan.status !== 'implementing') {
        throw new Error(`Plan must be 'implementing' to complete steps. Current status: ${plan.status}`);
    }
    if (stepIndex < 0 || stepIndex >= plan.steps.length) {
        throw new Error(`Step ${input.step} does not exist. Plan has ${plan.steps.length} steps.`);
    }
    if (plan.steps[stepIndex].status === 'done') {
        throw new Error(`Step ${input.step} is already completed.`);
    }
    await deps.runEvent(weaveId, { type: 'COMPLETE_STEP', planId: input.planUlid, stepIndex });
    const updatedWeave = await deps.loadWeave(deps.loomRoot, weaveId);
    const updatedPlan = updatedWeave.threads.flatMap((t) => t.plans).find((p) => p.id === input.planUlid);
    const autoCompleted = updatedPlan.status === 'done';
    return { plan: updatedPlan, autoCompleted };
}
